import {
  FormControl, FormControlLabel, Grid, Radio, RadioGroup,
} from '@mui/material';
import { DynamicAspect } from '../../../Blocks/BlockImageList/ImageSettings';

interface DynamicAspectOptionsProps {
  value: string;
  handleChange: (dynamicAspect: DynamicAspect) => void;
}

const DynamicAspectOptions = ({ value, handleChange }: DynamicAspectOptionsProps) => (
  <Grid item sx={{ width: '100%' }}>
    <FormControl>
      <RadioGroup
        name="aspect-ratio-radio-buttons-group"
        row
        value={value}
        onChange={(event) => handleChange((event.target as HTMLInputElement).value as DynamicAspect)}
      >
        <FormControlLabel value={DynamicAspect.Auto} control={<Radio size="small" />} label="比率を元画像に合わせる" />
      </RadioGroup>
    </FormControl>
  </Grid>
);

export default DynamicAspectOptions;
